import { LitElement, TemplateResult, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("text-notification")
export class TextNotification extends LitElement {
    public static styles = css`
        div {
            background-color: #f8fafc;
            border: 2px solid black;
            padding: 12px;
            display: flex;
            align-items: center;
            width: calc(100% - 48px);
            margin: 12px;
        }

        p {
            color: #020617;
            margin: 0;
            margin-left: 8px;
        }

        svg {
            color: #38bdf8;
            width: 24px;
            height: 24px;
        }
    `;

    @property() public message: string = "";
    @property({ type: Number }) public stayTimeMillis: number = 0;

    public connectedCallback(): void {
        super.connectedCallback();

        if(this.stayTimeMillis === 0) return;
        
        setTimeout(() => {
            this.remove();
        }, this.stayTimeMillis);
    }

    protected render(): TemplateResult {
        return html`
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
                </svg>
                <p>${this.message}</p>
            </div>
        `;
    }
}